import { render, staticRenderFns } from "./flowChart.vue?vue&type=template&id=0bcf937e&scoped=true"
import script from "./flowChart.vue?vue&type=script&lang=js"
export * from "./flowChart.vue?vue&type=script&lang=js"
import style0 from "./flowChart.vue?vue&type=style&index=0&id=0bcf937e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf937e",
  null
  
)

export default component.exports